import { PortalzugriffDisplayModel } from '@/api/model-index';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss']
})
export class AvatarComponent {

  @Input('avatar')
  public avatar: PortalzugriffDisplayModel;

  @Input('new')
  public new: boolean;

  @Input('vorschlagsliste')
  public vorschlagsliste: boolean;

  @Input('subtext')
  public subtext: string;

  @Output("addFunction") addFunction: EventEmitter<any> = new EventEmitter();
  @Output("removeFunction") removeFunction: EventEmitter<any> = new EventEmitter();

  public initals(): string {
    if (this.avatar.unregistrierterBenutzer == null)
      return this.avatar?.externerBenutzer?.firstname?.charAt(0) + "" + this.avatar?.externerBenutzer?.lastname?.charAt(0);
    else
      return "?";
  }

  public addAvatar(): void {
    this.addFunction.emit();
  }

  public removeAvatar(): void {
    this.removeFunction.emit();
  }

}
